import { RiMapPinLine } from "@itandi/itandi-bb-ui";
import { Box } from "@itandi/itandi-bb-ui/Box";
import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import cx from "clsx";
import type { ComponentProps } from "react";
import { DealTypeLabel } from "~/components/common/parts/label/DealTypeLabel";
import { MEDIA_QUERY, useMediaQuery } from "~/hooks/useMediaQuery";
import type { Deal } from "~/models/Deal";
import { formatPropertyName } from "~/models/Deal";
import Styles from "./DealLayoutHeader.module.scss";
import { SimpleHeaderVendorSP } from "./simple_header/SimpleHeaderVendorSP";

type Props = {
	deal: Deal;
	enableChat: boolean;
	isChatOpen: boolean;
	items: ComponentProps<
		typeof Breadcrumbs | typeof SimpleHeaderVendorSP
	>["items"];
	onToggleChat: () => void;
	useSimpleSpHeader: boolean;
};

export function DealLayoutHeaderVendor({
	deal,
	enableChat,
	isChatOpen,
	items,
	onToggleChat,
	useSimpleSpHeader
}: Props) {
	const { match: isSp, isLoaded: windowLoaded } = useMediaQuery(MEDIA_QUERY.sp);
	if (!windowLoaded) {
		return null;
	}
	return (
		<>
			{useSimpleSpHeader && isSp ? (
				<SimpleHeaderVendorSP deal={deal} items={items} />
			) : (
				<div className={Styles.DealHeader} id="deal_header">
					<div className={Styles.HeaderLeftContent}>
						<Box marginBottom={16}>
							<Breadcrumbs items={items} />
						</Box>
						<div className={Styles.HeaderElements}>
							<div className={Styles.AlignCenter}>
								<DealTypeLabel
									dealSubtype={deal.dealSubtype}
									dealType={deal.dealType}
								/>
							</div>
							<div>
								<h1 className={Styles.RoomName}>{formatPropertyName(deal)}</h1>
							</div>
							<div className={cx(Styles.AlignCenter, Styles.DealAddress)}>
								<RiMapPinLine className={Styles.Icon} />
								{deal.address}
							</div>
						</div>
					</div>
					<Flex alignItems="flex-end" justifyContent="end" ml="auto">
						{enableChat ? (
							<Button height="small" onClick={onToggleChat} variant="secondary">
								{isChatOpen ? "チャットを閉じる" : "管理会社とチャットする"}
							</Button>
						) : null}
					</Flex>
				</div>
			)}
		</>
	);
}
